import React from "react";
import { Switch, Route, useRouteMatch } from "react-router-dom";
import LayoutEventos from "../../components/layout-eventos";
import GestionarBitacora from "./index";
import Bitacora from "./bitacora";

const RouterBitacora = () => {
  const { path } = useRouteMatch();
  return (
    <LayoutEventos>
      <Switch>

        <Route exact path={`${path}`}>
          <GestionarBitacora />
        </Route>
        <Route exact path={`${path}/bitacora`}>
          <Bitacora />
        </Route>

      </Switch>
    </LayoutEventos>
  );
};

export default RouterBitacora;
